let accountbtns = document.querySelectorAll(".navBar-item a");

accountbtns.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    let sectionID = btn.getAttribute("data-target-id");
    if (document.querySelector(`#${sectionID}`)) {
      e.preventDefault();
      accountbtns.forEach((accountbtns) => {
        if (accountbtns != btn) {
          accountbtns.closest("li").classList.remove("is-active");
        }
      });
      document.querySelectorAll(".account-content").forEach((content) => {
        if (content != sectionID) {
          content.classList.add("d-none");
        }
      });
      btn.closest("li").classList.add("is-active");
      document.querySelector(`#${sectionID}`).classList.remove("d-none");
    }
  });
});

let customer_data = document.querySelector("[data-customer-json]");

let orderData, current_page, records_per_page, objJson, no_of_pages;

if (customer_data) {
  orderData = JSON.parse(customer_data.innerHTML);
  current_page = 1;
  records_per_page = 10;
  objJson = orderData.customer_orders;
  no_of_pages = Math.ceil(objJson.length / records_per_page);

  function prevPage() {
    if (current_page > 1) {
      current_page--;
      changePage(current_page);
    }
  }

  function nextPage() {
    if (current_page < no_of_pages) {
      current_page++;
      changePage(current_page);
    }
  }

  function changePage(page) {
    var btn_next = document.getElementById("btn_next");
    var btn_prev = document.getElementById("btn_prev");
    var listing_table = document.querySelector(".order-history tbody");
    var page_span = document.getElementById("page_num");
    let page_num = page;
    let html = "";

    // Validate page
    if (page < 1) page = 1;
    if (page > no_of_pages) page = no_of_pages;

    listing_table.innerHTML = "";
    for (
      var i = (page - 1) * records_per_page;
      i < page * records_per_page;
      i++
    ) {
      if (objJson[i]) {
        let splitDate = objJson[i].order_created_at.split(" -")[0];
        let replaceDate = splitDate.replace(" ", "T");
        const d = new Date(replaceDate);
        let getDay = d.getDate();
        let getMonth = d.toLocaleString("default", { month: "long" });
        let getYear = d.getFullYear();

        html += `<tr>
                  <th scope="row">
                    <a href="${objJson[i].order_url}" class="btn btn-lg btn-outline-secondary">${objJson[i].order_number}</a>
                  </th>
                  <td>${getMonth} ${getDay}, ${getYear}</td>
                  <td>${objJson[i].order_financial_status_label}</td>
                  <td>${objJson[i].order_fulfillment_status_label}</td>
                  <td>${objJson[i].order_total_price}</td>
                </tr>`;
      }
    }
    page_span.innerHTML = `Page ${page_num} of ${no_of_pages}`;
    listing_table.innerHTML = html;

    document.querySelector(".order-history").classList.remove("d-none");
    document
      .querySelector(".list--inline.pagination")
      .classList.remove("d-none");

    if (page == 1) {
      btn_prev.setAttribute("disabled", "true");
    } else {
      btn_prev.removeAttribute("disabled");
    }

    if (page == no_of_pages) {
      btn_next.setAttribute("disabled", "true");
    } else {
      btn_next.removeAttribute("disabled");
    }
  }
  changePage(1);
}
